import React, { ChangeEvent } from 'react';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';

import { WithTrack, withTrack } from '../../utils/analytics';
import updateMembershipPolicyType from '../../actions/thunks/updateMembershipPolicy';
import { IAppState, TMembershipPolicy } from '../../types/state.d';
import { getMembershipPolicy } from '../../selectors/apiSelectors';
import { apiThunk } from '../../actions/thunks';

export type Props = MembershipPolicyFormMapStateToProps &
  MembershipPolicyFormMapDispatchToProps &
  WithTrack;

export const MembershipPolicyForm = ({
  updateMembershipPolicy,
  membershipPolicy,
  track,
}: Props) => {
  function handleMembershipPolicyChange(event: ChangeEvent<HTMLInputElement>) {
    const policy = event.target.value as TMembershipPolicy;
    updateMembershipPolicy(policy);
    track({
      action_name: 'link click',
      subtype: 'button',
      event: 'link click',
      event_value: policy,
      page_section: 'admin > members',
    });
  }
  return (
    <form>
      <h1 className="jg-space-mbsm jg-h3">
        <Trans i18nKey="content.editmembers.heading" />
      </h1>
      <p className="jg-text--large jg-space-mbsm">
        <Trans i18nKey="content.editmembers.subtext" />
      </p>
      <fieldset>
        <legend className="jg-hidden-visually">
          Choose the way new team members can join
        </legend>
        <input
          type="radio"
          name="inviteOnly"
          className="jg-radio"
          onChange={handleMembershipPolicyChange}
          defaultChecked={membershipPolicy === 'open'}
          value={'open' as TMembershipPolicy}
          id="anyone-can-join"
        />
        <label
          htmlFor="anyone-can-join"
          className="jg-text--large-regular jg-display-b"
        >
          <Trans i18nKey="content.editmembers.anyonecanjoin" />
        </label>
        <input
          type="radio"
          name="inviteOnly"
          className="jg-radio"
          onChange={handleMembershipPolicyChange}
          defaultChecked={membershipPolicy === 'invite-only'}
          value={'invite-only' as TMembershipPolicy}
          id="invite-only"
        />
        <label
          htmlFor="invite-only"
          className="jg-text--large-regular jg-display-b"
        >
          <Trans i18nKey="content.editmembers.inviteonly" />
        </label>
      </fieldset>
    </form>
  );
};

type MembershipPolicyFormMapStateToProps = {
  membershipPolicy: TMembershipPolicy;
};

type MembershipPolicyFormMapDispatchToProps = {
  updateMembershipPolicy: typeof updateMembershipPolicyType;
};

export const mapStateToProps = (
  state: IAppState,
): MembershipPolicyFormMapStateToProps => ({
  membershipPolicy: getMembershipPolicy(state),
});

export const mapDispatchToProps: MembershipPolicyFormMapDispatchToProps = {
  updateMembershipPolicy: apiThunk.updateMembershipPolicy,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTrack(MembershipPolicyForm));
